export default "__VITE_ASSET__D2zQNPS5__"